import { Box } from '@mui/system'
import React, { useState } from 'react'

import HeroBanner from '../Components/HeroBanner'
import SearchExercises from '../Components/SearchExercises'
// import data from  "../utils/datasss.json"

const Home = () => {
  const [bodyPart,setBodyPart]=useState("all")
  const [exercise,setExercise]=useState([ ])
  return (
    <div>
      <Box>
        <HeroBanner />
        <SearchExercises setExercise={setExercise} setBodyPart={setBodyPart} bodyPart={bodyPart} />
      
        {/* {data.data.map((e)=>(
          <div className="">{e.bodyPart}</div>
        ))} */}
      </Box>
    </div>
  )
}

export default Home
